import { Outlet } from 'react-router-dom';

import ProjectScreenerOverlay from '../../components/ProjectScreenerOverlay';
import { useGlobalStore } from '../../stores/useGlobalStore';
import { usePermissions } from '../../utils/hooks/usePermissions';

import { ProjectScreenerStub } from './ProjectScreenerStub';

const ProjectScreenerGuard = () => {
  const { hasPermission } = usePermissions();
  const demoSession = useGlobalStore((s) => s.demoSession);
  const allowed =
    hasPermission('dashboard:project_screener') ||
    demoSession?.feature_key === 'dashboard:project_screener';

  if (!allowed) {
    return (
      <>
        <ProjectScreenerStub />
        <ProjectScreenerOverlay />
      </>
    );
  }
  return <Outlet />;
};

export { ProjectScreenerGuard };
